var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginInputWrapper"},[_c('small',[_vm._v(_vm._s(_vm.spanText))]),_vm._v(" "),_c('div',{staticClass:"loginInputFileWrapper"},[_c('button',{staticClass:"regCertBtn",on:{"click":_vm.openSignUpRegCertModal}},[_vm._v("추가")]),_vm._v(" "),_c('span',{staticClass:"fileName"},[_vm._v(_vm._s(_vm.fileName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0395e1ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/elements/loginInputFile.vue
// module id = null
// module chunks = 